<template>
  <section
    v-if="isBlocked"
    class="fixed inset-0 z-[2000] flex items-center justify-center bg-[var(--p-surface-0)]/95 px-4 backdrop-blur-sm dark:bg-[var(--p-surface-950)]/95"
    role="alertdialog"
    aria-modal="true"
    :aria-label="t('session.tab_blocked_title')"
  >
    <div
      class="flex w-full max-w-md flex-col items-center gap-4 rounded-xl bg-[var(--p-surface-0)] p-6 text-center shadow-[0_8px_32px_-8px_rgb(0_0_0/0.2)] ring-1 ring-[var(--p-surface-200)] dark:bg-[var(--p-surface-900)] dark:ring-[var(--p-surface-700)]"
    >
      <span
        class="flex h-11 w-11 items-center justify-center rounded-lg bg-amber-500/10"
        aria-hidden="true"
      >
        <AppWindowIcon class="h-5 w-5 text-amber-500" />
      </span>

      <div class="flex flex-col gap-1.5">
        <h2 class="text-base font-medium tracking-tight text-[var(--p-text-color)]">
          {{ t('session.tab_blocked_title') }}
        </h2>
        <p class="text-sm leading-5 text-[var(--p-text-muted-color)]">
          {{ t('session.tab_blocked_body') }}
        </p>
      </div>

      <AppButton
        :label="t('session.tab_blocked_action')"
        severity="primary"
        size="small"
        class="mt-1"
        @click="takeOver"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import AppButton from 'primevue/button'
import { AppWindowIcon } from 'lucide-vue-next'

import { useTabSessionStore } from '@/stores/useTabSessionStore'

const { t } = useI18n()
const tabSession = useTabSessionStore()

const isBlocked = computed(() => tabSession.status === 'blocked')

const takeOver = () => tabSession.takeOver()
</script>
